import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFilter } from '../../../../../../stores/algos-list/getters';
import { makeStyles } from '@material-ui/core';
import Count from './Count';
import { useState } from 'react';
import ViewActiveModal from './ViewActiveModal';
import { updateFilter } from '../../../../../../stores/algos-list/actions';
import CellDud from '../../CellDud';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
  },
}));

function useHasAnyValue() {
  const views = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });

  return Object.keys(views ?? {}).length > 0;
}

const ViewActive = () => {
  const classes = useStyles();
  const isActive = useHasAnyValue();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  function onClearAllFilters() {
    dispatch(
      updateFilter({
        views: undefined,
      })
    );

    onClose();
  }

  if (!isActive) {
    return <CellDud />;
  }

  return (
    <div className={classes.root}>
      <Count onClick={onOpen} />
      <ViewActiveModal
        open={open}
        onClose={onClose}
        onConfirm={onClearAllFilters}
      />
    </div>
  );
};

export default ViewActive;
